import {TOGGLE_STATIC_OBJECTS} from "../constants/action-types";
import productSettings from "../services/product-settings";
import Mediator from "../services/Mediator";
import {applyConditionToCanvas} from "./apply-condition-to-canvas";

const getSideIndex = (metaDesigns, side) => {
  return metaDesigns.reduce(
    (acc, item, i) => (item.side === side ? i : acc),
    0
  );
};

const getDesignsWithoutStaticObjects = (designs) => {
  return Object.values(designs).reduce((acc, item, index) => {
    const {design} = item;
    const objectsWithoutStatic = design.objects.filter((o) => !o.static);
    return {
      ...acc,
      [index]: {
        ...item,
        design: {
          ...design,
          objects: objectsWithoutStatic
        }
      }
    };
  }, {});
};
const getDesignsWithStaticObjects = async (
  designs,
  objectToLoad,
  metaDesigns
) => {
  const promisesForStaticObjects = [];
  const modifingDesings = {};
  for (let objectKey in objectToLoad) {
    if (objectToLoad.hasOwnProperty(objectKey)) {
      const sideIndex = getSideIndex(metaDesigns, objectKey);
      const {path, ...options} = objectToLoad[objectKey];
      modifingDesings[sideIndex] = designs[sideIndex];
      promisesForStaticObjects.push(
        Mediator.loadSVGFromURL(path, {
          ...options,
          hasBorders: false,
          hasControls: false,
          selectable: false,
          evented: false,
          static: true
        })
      );
    }
  }
  const staticObjects = await Promise.all(promisesForStaticObjects);
  const modifiedDesigns = {};
  let i = 0;
  for (const modifingDesingsKey in modifingDesings) {
    if (modifingDesings.hasOwnProperty(modifingDesingsKey)) {
      const element = modifingDesings[modifingDesingsKey];
      const staticObject = staticObjects[i].toObject([
        `selectable`,
        `hasControls`,
        `hasBorders`,
        `static`,
        `evented`
      ]);

      modifiedDesigns[modifingDesingsKey] = element;
      modifiedDesigns[modifingDesingsKey].design.objects.push(staticObject);
      i++;
    }
  }
  return {
    ...designs,
    ...modifiedDesigns
  };
};

const getDesigns = (getState) => {
  const {
    condition: {product},
    designs,
    product: {
      meta: {designs: metaDesigns}
    }
  } = getState();
  const settings = productSettings[product];
  const designsWithoutStaticObjects = getDesignsWithoutStaticObjects(designs);
  if (settings && settings.objectToLoad) {
    return getDesignsWithStaticObjects(
      designsWithoutStaticObjects,
      settings.objectToLoad,
      metaDesigns
    );
  } else {
    return designsWithoutStaticObjects;
  }
};

export const toggleStaticObjects = (prevCondition) => async (
  dispatch,
  getState
) => {
  try {
    const designsWithInitialStaticObjects = await getDesigns(getState);
    dispatch({
      type: TOGGLE_STATIC_OBJECTS,
      payload: {
        designs: designsWithInitialStaticObjects
      }
    });
    dispatch(applyConditionToCanvas(prevCondition));
  } catch (err) {
    throw err;
  }
};
